export default __webpack_public_path__ + "static/media/csv.7df78d2f.svg";